import './styles.css';
import React, { useState } from 'react';
import { Modal, Button, Icon, Header } from 'semantic-ui-react';
import {useDispatch, useSelector} from "react-redux";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";
import {getTypeExhibition} from "../../views/Home/reducer";
import CloseAsia from "../../icons/close-red-icon.svg";
import CloseGras from "../../icons/close-green-icon.svg";
import {openAuth} from "../NavTopBar/actions";
import {AUTH_SCREEN_MAIN, AUTH_SCREEN_SIGNUP, setAuthScreen} from "../UserLogin/actions";

const UnloginPopup = ({open, setOpen, text}) => {
    const dispatch = useDispatch();
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));

    const getCloseIcon = () => {
        const icons = {
            asia: <img src={CloseAsia} alt="Close" style={{ width: 15, height: 15, position: 'absolute',top: '5px', right: '5px'}} />,
            gras: <img src={CloseGras} alt="Close" style={{ width: 15, height: 15, position: 'absolute',top: '5px', right: '5px'}} />,
        };
        return icons[typeExhibition] || <Icon name="close" />;
    };

    return (
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                size="small"
                centered
                closeIcon={getCloseIcon()}
            >
                <Modal.Content style={{textAlign: 'center'}}>
                    <div className='unlogin-header' style={{margin: '0 0 10px 0'}}>{t('dearUser')}</div>
                    <p>{text}</p>
                    <div className='unlogin-btns'>
                        <button onClick={() => {
                            setOpen(false);
                            dispatch(openAuth())
                            dispatch(setAuthScreen(AUTH_SCREEN_SIGNUP))
                        }} className={`unlogin-btn ${typeExhibition}`}>{t('toRegister')}</button>
                        <button onClick={() => {
                            setOpen(false);
                            dispatch(openAuth())
                            dispatch(setAuthScreen(AUTH_SCREEN_MAIN))
                        }} className={`unlogin-btn ${typeExhibition}`}>{t('login')}</button>
                    </div>

                </Modal.Content>
            </Modal>
    );
};

export default UnloginPopup;